<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Cancel Contract / Test Activation
</div>
<p-card>
    <form #cancelForm="ngForm" (ngSubmit)="onCancelContractClicked()" novalidate>
    <div class="form-group">
        <div class="field-inputs">
            <label for="pac" class="required-field">PAC : 
            </label>
            <input
                id="pac"
                class="form-control"
                pattern="^[a-zA-Z0-9]+$"
                maxlength="13"
                minlength="12"
                [(ngModel)]="pacData.pac" name="pac"
                #pac="ngModel"
                required
                pInputText />
            <label for="manufacturer" class="required-field">Manufacturer : </label>
            <p-dropdown 
                [options]="manufacturers"
                [filter] ="true"
                [(ngModel)]="selectedManufaturer"
                placeholder="Select Manufacturer" 
                optionLabel="manufacturerName"
                [ngModelOptions]="{standalone: true}"
                optionValue="manufacturerName"></p-dropdown>
            <div class="info-wrapper">
                <span>
                    <i class="pi pi-info-circle"></i>Selected manufacturer must match specified PAC(s) for cancellation to succeed.
                </span>
            </div>
        </div>
        <div class="error-msg"*ngIf="pac.invalid && (pac.dirty || pac.touched)">
            <span *ngIf="pac?.errors?.required">
                PAC is required</span>
            <span *ngIf="pac?.errors?.pattern">
               PAC should be alphanumeric</span>
            <span *ngIf="pac?.errors?.maxlength && !pac?.errors?.pattern">
                Maximum length of the PAC should be 13
            </span>
            <span *ngIf="pac?.errors?.minlength && !pac?.errors?.pattern">
                Minimum length of the PAC should be 12
            </span>
        </div>

        <div class="field-inputs">
            <label for="contract-id" class="">Contract Id : </label>
            <p-inputNumber
                [(ngModel)]="contractId"
                id="contract-id" inputId="withoutgrouping"
                [ngModelOptions]="{standalone: true}"
                [useGrouping]="false" (onInput)="onContractIdChange($event)"></p-inputNumber>
            <p-checkbox [(ngModel)]="cancelSpecificContract" [binary]="true" inputId="cancel-specific-contract" (onChange)="onCheck($event)"  [ngModelOptions]="{standalone: true}"
            ></p-checkbox>
            <label class="checkbox-label" for="cancel-specific-contract" [ngClass]="{'required-field1': cancelCheckBoxMandate}">Cancel Specific Contract</label>
        </div>
        <div class="field-inputs">
            <div class="notes-buttons-wrapper">
                <div class="notes-wrapper">
                    <label for="notes">Notes : </label>
                    <textarea 
                        id="notes" 
                        pInputTextarea
                        placeholder="Reason to Cancel" 
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="notes"></textarea>
                </div>
                <div class="field-buttons" >
                    <small></small>
                    <!-- <small 
                        [ngClass]="{'error': hasError, 'success': !hasError, 'visible': responseMessage.length > 0}">{{responseMessage}}</small> -->
                    <button 
                        pButton 
                        [disabled]="pac.invalid || contractId === 0 || selectedManufaturer === undefined || cancelBtnEnable"
                        type="submit" 
                        label="Cancel Contract"></button>
                </div>
            </div>
            <div class="info-wrapper">
                <span>
                    <i class="pi pi-info-circle"></i>Notes:
                </span>
                <span>
                    - If no Contract ID is entered, all contracts for the PAC will be cancelled and the unit will be deactivated.
                </span>
                <span>
                    - Renewals and Pending Activations can be cancelled by specifying a Contract ID.
                </span>
                <span>
                    - Active contracts and test activations cannot be cancelled if there is a pending contract.
                </span>
            </div>
        </div>
    </div>
    </form>
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>